import { TransactionType } from "@/type/core/transaction/transaction.types";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

const SEALING_FONT_SIZE_RATIO = 600;
const SIGNATURE_FONT_SIZE_RATIO = 450;

interface SignatoryCardSignedByTextProps {
  firstname: string;
  lastname: string;
  cardDimensionWidth: number;
  transactionType: TransactionType;
}

const SignatoryCardSignedByText: FunctionComponent<
  SignatoryCardSignedByTextProps
> = ({ firstname, lastname, cardDimensionWidth, transactionType }) => {
  const { t } = useTranslation();
  const fontSizeRatio =
    transactionType === "signature"
      ? SIGNATURE_FONT_SIZE_RATIO
      : SEALING_FONT_SIZE_RATIO;

  return (
    <div className="text-left pl-2 w-100">
      <p
        className="mb-0 white-space-pre-line"
        style={{ fontSize: `${cardDimensionWidth / fontSizeRatio}rem` }}
      >
        {t("signature.signatureBy", {
          firstname,
          lastname,
          date: new Date().toLocaleDateString(),
        })}
      </p>
    </div>
  );
};

export default SignatoryCardSignedByText;
